import { render, staticRenderFns } from "./Listings.vue?vue&type=template&id=4d8aa80c"
import script from "./Listings.vue?vue&type=script&lang=js"
export * from "./Listings.vue?vue&type=script&lang=js"
import style0 from "./Listings.vue?vue&type=style&index=0&id=4d8aa80c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports